<div (click)="onWrapperClick($event)">
  <p-tabView [(activeIndex)]="activeTabIndex">
    <p-tabPanel header="Rate" (click)="onTabChange(0)" id="0">
      <!--<ng-template *ngIf="activeTabIndex === 0">-->
      <p-toast [style]="{marginTop: '80px'}"></p-toast>
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
      @if (formLoading) {
        <div class="kbm-search-loading">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div [formGroup]="form1" class="forms w-100 d-block ops-dashboard-top">
        <div class="row">
          <div class="col-lg-2 mt-4">
            <span class="p-float-label w-100 mb-3">
              <p-calendar formControlName="startDate" [showTime]="true"
                [hourFormat]="24" inputId="startDate" >
              </p-calendar>
              <label for="startDate">Season Start</label>
              @for (validation of validationMessages.startDate; track validation) {
                <span>
                  @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-2 mt-4">
            <button pButton class="btn-addt p-button" (click)="getDashboardDetails()">Search</button>
            <button pButton class="btn-addt p-button ml-2" (click)="syncDashboardDetails()">Sync Dashboard</button>
          </div>
        </div>

        <div class="ops-dashboard-table">
          <div class="col-4">
            <div class="table-bx bgYellow">
              <div class="table-bx-title">
                <h3>YIELDMAX <span>Last Update: {{lastUpdatedYieldMaxDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6># Rates</h6>
                      <span>YM -> Wiki</span>
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'today', 'CREATE_DATE')">{{rateCreateCounts?.todayCounts}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'today', 'UPDATE_DATE')">{{rateModifiedCounts?.todayCounts}}</a></h4>
                      @if (rateErrorRecordCounts?.todayErrorCounts > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', '', 'today')">{{rateErrorRecordCounts?.todayErrorCounts}}</a></span>
                      }
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'yesterday', 'CREATE_DATE')">{{rateCreateCounts?.yesterdayCount}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'yesterday', 'UPDATE_DATE')">{{rateModifiedCounts?.yesterdayCount}}</a></h4>
                      @if (rateErrorRecordCounts?.yesterdayErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', '', 'yesterday')">{{rateErrorRecordCounts?.yesterdayErrorCount}}</a></span>
                      }
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'avg', 'CREATE_DATE')">{{rateCreateCounts?.avgDayscount | number : '1.0-2'}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES', 'avg', 'UPDATE_DATE')">{{rateModifiedCounts?.avgDayscount | number : '1.0-2'}}</a></h4>
                      @if (rateErrorRecordCounts?.avgDaysErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', '', 'avg')">{{rateErrorRecordCounts?.avgDaysErrorCount | number : '1.0-2'}}</a></span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># LOS</h6>
                      <span>YM -> Wiki</span>
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'today', 'CREATE_DATE')">{{rateLosCreateCounts?.todayCounts}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'today', 'UPDATE_DATE')">{{rateLosModifiedCounts?.todayCounts}}</a></h4>
                      @if (rateLosErrorRecordCounts?.todayErrorCounts > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', '', 'today')">{{rateLosErrorRecordCounts?.todayErrorCounts}}</a></span>
                      }
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'yesterday', 'CREATE_DATE')">{{rateLosCreateCounts?.yesterdayCount}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'yesterday', 'UPDATE_DATE')">{{rateLosModifiedCounts?.yesterdayCount}}</a></h4>
                      @if (rateLosErrorRecordCounts?.yesterdayErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', '', 'yesterday')">{{rateLosErrorRecordCounts?.yesterdayErrorCount}}</a></span>
                      }
                    </td>
                    <td class="addbg">
                      <h4><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'avg', 'CREATE_DATE')">{{rateLosCreateCounts?.avgDayscount | number : '1.0-2'}}</a> | <a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RATES_LOS', 'avg', 'UPDATE_DATE')">{{rateLosModifiedCounts?.avgDayscount | number : '1.0-2'}}</a></h4>
                      @if (rateLosErrorRecordCounts?.avgDaysErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', '', 'avg')">{{rateLosErrorRecordCounts?.avgDaysErrorCount | number : '1.0-2'}}</a></span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Properties</h6>
                      <span>Wiki -> YM</span>
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'today', 'CREATE_DATE')">{{propertyCreateCounts?.todayCounts}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'today', 'UPDATE_DATE')">{{propertyModifiedCounts?.todayCounts}}</a></h4>
                      @if (propertyErrorRecordCounts?.todayErrorCounts > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', '', 'today')">{{propertyErrorRecordCounts?.todayErrorCounts}}</a></span>
                      }
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'yesterday', 'CREATE_DATE')">{{propertyCreateCounts?.yesterdayCount}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'yesterday', 'UPDATE_DATE')">{{propertyModifiedCounts?.yesterdayCount}}</a></h4>
                      @if (propertyErrorRecordCounts?.yesterdayErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', '', 'yesterday')">{{propertyErrorRecordCounts?.yesterdayErrorCount}}</a></span>
                      }
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'avg', 'CREATE_DATE')">{{propertyCreateCounts?.avgDayscount | number : '1.0-2'}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('PROPERTY', 'avg', 'UPDATE_DATE')">{{propertyModifiedCounts?.avgDayscount | number : '1.0-2'}}</a></h4>
                      @if (propertyErrorRecordCounts?.avgDaysErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', '', 'avg')">{{propertyErrorRecordCounts?.avgDaysErrorCount | number : '1.0-2'}}</a></span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Reservations</h6>
                      <span>Wiki -> YM</span>
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'today', 'CREATE_DATE')">{{yieldMaxReservationCreateCounts?.todayCounts}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'today', 'UPDATE_DATE')">{{yieldMaxReservationModifiedCounts?.todayCounts}}</a></h4>
                      @if (yieldMaxReservationErrorRecordCounts?.todayErrorCounts > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', '', 'today')">{{yieldMaxReservationErrorRecordCounts?.todayErrorCounts}}</a></span>
                      }
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'yesterday', 'CREATE_DATE')">{{yieldMaxReservationCreateCounts?.yesterdayCount}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'yesterday', 'UPDATE_DATE')">{{yieldMaxReservationModifiedCounts?.yesterdayCount}}</a></h4>
                      @if (yieldMaxReservationErrorRecordCounts?.yesterdayErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', '', 'yesterday')">{{yieldMaxReservationErrorRecordCounts?.yesterdayErrorCount}}</a></span>
                      }
                    </td>
                    <td>
                      <h4><a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'avg', 'CREATE_DATE')">{{yieldMaxReservationCreateCounts?.avgDayscount | number : '1.0-2'}}</a> | <a style="color: black;" href="javascript:void(0);" (click)="onYieldMaxSuccessClick('RESERVATION', 'avg', 'UPDATE_DATE')">{{yieldMaxReservationModifiedCounts?.avgDayscount | number : '1.0-2'}}</a></h4>
                      @if (yieldMaxReservationErrorRecordCounts?.avgDaysErrorCount > 0) {
                        <span class="textbg"><a style="color: white;" href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', '', 'avg')">{{yieldMaxReservationErrorRecordCounts?.avgDaysErrorCount | number : '1.0-2'}}</a></span>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-4">
            <div class="table-bx bgGreen">
              <div class="table-bx-title">
                <h3><a style="color: white;" href="javascript:void(0);" (click)="onReviewHdrClick()">REVIEWS </a><span>Last Update: {{lastUpdatedReviewDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6>Sent</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{reviewSentCounts?.todayCounts}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{reviewSentCounts?.yesterdayCount}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{reviewSentCounts?.avgDayscount}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Clicked</h6>
                    </td>
                    <td class="addbg">
                      <h4>NA</h4>
                    </td>
                    <td class="addbg">
                      <h4>NA</h4>
                    </td>
                    <td class="addbg">
                      <h4>NA</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Received</h6>
                    </td>
                    <td  class="addbg">
                      <h4>{{reviewCreateCounts?.todayCounts}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{reviewCreateCounts?.yesterdayCount}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{reviewCreateCounts?.avgDayscount}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>5 Star</h6>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail1?.fiveStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail2?.fiveStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail3?.fiveStartRating | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>4 Star</h6>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail1?.fourStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail2?.fourStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail3?.fourStartRating | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>3 Star</h6>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail1?.threeStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail2?.threeStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail3?.threeStartRating | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>2 Star</h6>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail1?.twoStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail2?.twoStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail3?.twoStartRating | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>1 Star</h6>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail1?.oneStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail2?.oneStartRating | number : '1.0-0'}}</h4>
                    </td>
                    <td>
                      <h4>{{wikiReview?.opsDashboardDetail3?.oneStartRating | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-4">
            <div class="table-bx bgBlue">
              <div class="table-bx-title">
                <h3><a style="color: white;" href="javascript:void(0);" (click)="onReservationSaleHdrClick()">RESERVATION SALES </a><span>Last Update: {{lastUpdatedReservationSalesDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6>Gross Rev $</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{todayRevRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{yesterdayRevRoomRateNetTTL | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{(fourteenDaysRevRoomRateNetTTL / 14) | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Average Revenue $</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{todayRevRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{yesterdayRevRoomRateNetAVG | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{(fourteenDaysRevRoomRateNetAVG / 14) | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Gross Resort Fee $</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{todayRevResortTTL | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{yesterdayRevResortTTL | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{(fourteenDaysRevResortTTL / 14) | currency : 'USD' : 'symbol' : '1.0-0'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Nights</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{todayNumNtsGuestTTL  | number : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{yesterdayNumNtsGuestTTL  | number : '1.0-0'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{(fourteenDaysNumNtsGuestTTL / 14)  | number : '1.0-0'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Nights Average</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{todayNumNtsGuestAVG  | number : '1.0-2'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{yesterdayNumNtsGuestAVG  | number : '1.0-2'}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{(fourteenDaysNumNtsGuestAVG)  | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Reservations</h6>
                    </td>
                    <td>
                      <h4>{{todayReservationTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{yesterdayReservationTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{(fourteenDaysReservationTTL / 14) | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Homeowner</h6>
                    </td>
                    <td>
                      <h4>{{todayOwnerReservationTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{yesterdayOwnerReservationTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{fourteenDaysOwnerReservationTTL}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Hold</h6>
                    </td>
                    <td>
                      <h4>{{todayNumNtsHoldTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{yesterdayNumNtsHoldTTL}}</h4>
                    </td>
                    <td>
                      <h4>{{fourteenDaysNumNtsHoldTTL}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Quotes Sent</h6>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6># Emails Rcvd</h6>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                    <td>
                      <h4>NA</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-4">
            <div class="table-bx bgPurple">
              <div class="table-bx-title">
                <h3>RENTALS UNITED <span>Last Update: {{lastUpdatedRentalUnitedDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6>Reservations</h6>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{rUReservationCreateCounts?.todayCounts}}</h4>
                        <h4>{{rUReservationModifiedCounts?.todayCounts}}</h4>
                        <!-- <h4>1</h4> -->
                      </div>
                      @if (rUReservationErrorRecordCounts?.todayErrorCounts > 0) {
                        <span class="textbg">{{rUReservationErrorRecordCounts?.todayErrorCounts}}</span>
                      }
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{rUReservationCreateCounts?.yesterdayCount}}</h4>
                        <h4>{{rUReservationModifiedCounts?.yesterdayCount}}</h4>
                        <!-- <h4>2</h4> -->
                      </div>
                      @if (rUReservationErrorRecordCounts?.yesterdayErrorCount > 0) {
                        <span class="textbg">{{rUReservationErrorRecordCounts?.yesterdayErrorCount}}</span>
                      }
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{rUReservationCreateCounts?.avgDayscount}}</h4>
                        <h4>{{rUReservationModifiedCounts?.avgDayscount}}</h4>
                        <!-- <h4>1.2</h4> -->
                      </div>
                      @if (rUReservationErrorRecordCounts?.avgDaysErrorCount > 0) {
                        <span class="textbg">{{rUReservationErrorRecordCounts?.avgDaysErrorCount}}</span>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Pricing</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{ruPricingCreateCounts?.todayCounts}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{ruPricingCreateCounts?.yesterdayCount}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{ruPricingCreateCounts?.avgDayscount}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Availablity</h6>
                    </td>
                    <td>
                      <h4>{{ruAvailabilityCreateCounts?.todayCounts}}</h4>
                    </td>
                    <td>
                      <h4>{{ruAvailabilityCreateCounts?.yesterdayCount}}</h4>
                    </td>
                    <td>
                      <h4>{{ruAvailabilityCreateCounts?.avgDayscount}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Property</h6>
                    </td>
                    <td>
                      <h4>{{ruPropertyCreateCounts?.todayCounts}}</h4>
                    </td>
                    <td>
                      <h4>{{ruPropertyCreateCounts?.yesterdayCount}}</h4>
                    </td>
                    <td>
                      <h4>{{ruPropertyCreateCounts?.avgDayscount}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-4">
            <div class="table-bx bgYellow">
              <div class="table-bx-title">
                <h3>In / Out <span>Last Update: {{lastUpdatedInOutDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6>In | Out</h6>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{inOutDashboardAPI?.totalInToday}} | {{inOutDashboardAPI?.totalOutToday}}</h4>
                      </div>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{inOutDashboardAPI?.totalInYesterday}} | {{inOutDashboardAPI?.totalOutYesterday}}</h4>
                      </div>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{inOutDashboardAPI?.totalInAvg | number : '1.0-2'}} | {{inOutDashboardAPI?.totalOutAvg | number : '1.0-2'}}</h4>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Reserved</h6>
                    </td>
                    <td class="addbg">
                      <h4>{{inOutDashboardAPI?.guestInToday}} | {{inOutDashboardAPI?.guestOutToday}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{inOutDashboardAPI?.guestInYesterday}} | {{inOutDashboardAPI?.guestOutYesterday}}</h4>
                    </td>
                    <td class="addbg">
                      <h4>{{inOutDashboardAPI?.guestInAvg | number : '1.0-2'}} | {{inOutDashboardAPI?.guestOutAvg | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Owners</h6>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerInToday}} | {{inOutDashboardAPI?.ownerOutToday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerInYesterday}} | {{inOutDashboardAPI?.ownerOutYesterday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerInAvg | number : '1.0-2'}} | {{inOutDashboardAPI?.ownerOutAvg | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Owner Guest</h6>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerGuestInToday}} | {{inOutDashboardAPI?.ownerGuestOutToday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerGuestInYesterday}} | {{inOutDashboardAPI?.ownerGuestOutYesterday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.ownerGuestInAvg | number : '1.0-2'}} | {{inOutDashboardAPI?.ownerGuestOutAvg | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Maintenance</h6>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.maintenanceInToday}} | {{inOutDashboardAPI?.maintenanceOutToday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.maintenanceInYesterday}} | {{inOutDashboardAPI?.maintenanceOutYesterday}}</h4>
                    </td>
                    <td>
                      <h4>{{inOutDashboardAPI?.maintenanceInAvg | number : '1.0-2'}} | {{inOutDashboardAPI?.maintenanceOutAvg | number : '1.0-2'}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-4">
            <div class="table-bx bgGreen">
              <div class="table-bx-title">
                <h3>BLOGS <span>Last Update: {{lastUpdatedBlogsDashboard | date:'MM/dd h:mm a'}}</span></h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div>
                        <h6>Today</h6>
                        <span>{{todayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>Yesterday</h6>
                        <span>{{yesterdayDate | date:'EEE MMM d'}}</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <h6>14-Day Avg</h6>
                        <span>{{fourteenDayDate | date:'MMM d'}} - {{todayDate | date:'MMM d'}}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6>Blogs</h6>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{blogCreateCounts?.todayCounts}}</h4>
                      </div>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{blogCreateCounts?.yesterdayCount}}</h4>
                      </div>
                    </td>
                    <td class="addbg">
                      <div class="d-flex listnumber">
                        <h4>{{blogCreateCounts?.avgDayscount}}</h4>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <hr>
          <app-rates-report></app-rates-report>

          <hr>
            <h2>YieldMax</h2>
            <div class="row">
              <div class="col-3">
                <div class="mt-4 ml-2">
                  <p>SUCCESS SYNCED RATES (4 Hours) : {{yieldMaxRates?.yieldMaxDetail1?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES (4 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', 4, '')">{{yieldMaxRates?.yieldMaxDetail1?.rateSyncNumError}}</a></p>
                </div>
                <div class="mt-4 ml-2">
                  <p>SUCCESS SYNCED RATES (12 Hours) : {{yieldMaxRates?.yieldMaxDetail2?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES (12 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', 12, '')">{{yieldMaxRates?.yieldMaxDetail2?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4 ml-2">
                  <p>SUCCESS SYNCED RATES (24 Hours) : {{yieldMaxRates?.yieldMaxDetail3?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES (24 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES', 24, '')">{{yieldMaxRates?.yieldMaxDetail3?.rateSyncNumError}}</a> </p>
                </div>
              </div>
              <div class="col-3">
                <div class="mt-4">
                  <p>SUCCESS SYNCED RATE LOS (4 Hours) : {{yieldMaxRateLos?.yieldMaxDetail1?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES LOS (4 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', 4, '')">{{yieldMaxRateLos?.yieldMaxDetail1?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED RATE LOS (12 Hours) : {{yieldMaxRateLos?.yieldMaxDetail2?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES LOS (12 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', 12, '')">{{yieldMaxRateLos?.yieldMaxDetail2?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED RATE LOS (24 Hours) : {{yieldMaxRateLos?.yieldMaxDetail3?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RATES LOS (24 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_RATES_LOS', 24, '')">{{yieldMaxRateLos?.yieldMaxDetail3?.rateSyncNumError}}</a> </p>
                </div>
              </div>
              <div class="col-3">
                <div class="mt-4">
                  <p>SUCCESS SYNCED PROPERTIES (4 Hours) : {{properties?.yieldMaxDetail1?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED PROPERTIES (4 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', 4, '')">{{properties?.yieldMaxDetail1?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED PROPERTIES (12 Hours) : {{properties?.yieldMaxDetail2?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED PROPERTIES (12 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', 12, '')">{{properties?.yieldMaxDetail2?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED PROPERTIES (24 Hours) : {{properties?.yieldMaxDetail3?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED PROPERTIES (24 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_PROPERTY', 24, '')">{{properties?.yieldMaxDetail3?.rateSyncNumError}}</a> </p>
                </div>
              </div>
              <div class="col-3">
                <div class="mt-4">
                  <p>SUCCESS SYNCED RESERVATIONS (4 Hours) : {{reservations?.yieldMaxDetail1?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RESERVATIONS (4 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', 4, '')">{{reservations?.yieldMaxDetail1?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED RESERVATIONS (12 Hours) : {{reservations?.yieldMaxDetail2?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RESERVATIONS (12 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', 12, '')">{{reservations?.yieldMaxDetail2?.rateSyncNumError}}</a> </p>
                </div>
                <div class="mt-4">
                  <p>SUCCESS SYNCED RESERVATIONS (24 Hours) : {{reservations?.yieldMaxDetail3?.rateSyncNumSuccess}} </p>
                  <p>ERROR   SYNCED RESERVATIONS (24 Hours) : <a href="javascript:void(0);" (click)="onYieldMaxErrorClick('ERROR', 'SYNC_EXTERNAL_RESERVATION', 24, '')">{{reservations?.yieldMaxDetail3?.rateSyncNumError}}</a> </p>
                </div>
              </div>
            </div>
            <hr>
              <div class="row">
                <div class="col-3">
                  <div class="mt-4 ml-2">
                    <p>SYNCED RATES Min Time in Sec (4 Hours) : {{yieldMaxRates?.yieldMaxDetail1?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATES Avg Time in Sec (4 Hours) : {{yieldMaxRates?.yieldMaxDetail1?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATES Max Time in Sec (4 Hours) : {{yieldMaxRates?.yieldMaxDetail1?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                  <div class="mt-4 ml-2">
                    <p>SYNCED RATES Min Time in Sec (12 Hours) : {{yieldMaxRates?.yieldMaxDetail2?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATES Avg Time in Sec (12 Hours) : {{yieldMaxRates?.yieldMaxDetail2?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATES Max Time in Sec (12 Hours) : {{yieldMaxRates?.yieldMaxDetail2?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                  <div class="mt-4 ml-2">
                    <p>SYNCED RATES Min Time in Sec (24 Hours) : {{yieldMaxRates?.yieldMaxDetail3?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATES Avg Time in Sec (24 Hours) : {{yieldMaxRates?.yieldMaxDetail3?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATES Max Time in Sec (24 Hours) : {{yieldMaxRates?.yieldMaxDetail3?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                </div>
                <div class="col-3">
                  <div class="mt-4">
                    <p>SYNCED RATE LOS Min Time in Sec (4 Hours) : {{yieldMaxRateLos?.yieldMaxDetail1?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATE LOS Avg Time in Sec (4 Hours) : {{yieldMaxRateLos?.yieldMaxDetail1?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATE LOS Max Time in Sec (4 Hours) : {{yieldMaxRateLos?.yieldMaxDetail1?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                  <div class="mt-4">
                    <p>SYNCED RATE LOS Min Time in Sec (12 Hours) : {{yieldMaxRateLos?.yieldMaxDetail2?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATE LOS Avg Time in Sec (12 Hours) : {{yieldMaxRateLos?.yieldMaxDetail2?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATE LOS Max Time in Sec (12 Hours) : {{yieldMaxRateLos?.yieldMaxDetail2?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                  <div class="mt-4">
                    <p>SYNCED RATE LOS Min Time in Sec (24 Hours) : {{yieldMaxRateLos?.yieldMaxDetail3?.rateSyncProcTime?.minProcTime}} </p>
                    <p>SYNCED RATE LOS Avg Time in Sec (24 Hours) : {{yieldMaxRateLos?.yieldMaxDetail3?.rateSyncProcTime?.avgProcTime}} </p>
                    <p>SYNCED RATE LOS Max Time in Sec (24 Hours) : {{yieldMaxRateLos?.yieldMaxDetail3?.rateSyncProcTime?.maxProcTime}} </p>
                  </div>
                </div>
              </div>
              <hr>
                <h2>WiKi</h2>
                <div class="row">
                  <div class="col-3">
                    <div class="mt-4 ml-2">
                      <p>SUCCESS SYNCED RATES (4 Hours) : {{wikiRates?.opsDashboardDetail1?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES (4 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_FROM_YIELDMAX', 4)">{{wikiRates?.opsDashboardDetail1?.rateSyncNumError}}</a> </p>
                    </div>
                    <div class="mt-4 ml-2">
                      <p>SUCCESS SYNCED RATES (12 Hours) : {{wikiRates?.opsDashboardDetail2?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES (12 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_FROM_YIELDMAX', 12)">{{wikiRates?.opsDashboardDetail2?.rateSyncNumError}}</a> </p>
                    </div>
                    <div class="mt-4 ml-2">
                      <p>SUCCESS SYNCED RATES (24 Hours) : {{wikiRates?.opsDashboardDetail3?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES (24 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_FROM_YIELDMAX', 24)">{{wikiRates?.opsDashboardDetail3?.rateSyncNumError}}</a> </p>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="mt-4">
                      <p>SUCCESS SYNCED RATE LOS (4 Hours) : {{wikiRateLos?.opsDashboardDetail1?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES LOS (4 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_LOS_FROM_YIELDMAX', 4)">{{wikiRateLos?.opsDashboardDetail1?.rateSyncNumError}}</a> </p>
                    </div>
                    <div class="mt-4">
                      <p>SUCCESS SYNCED RATE LOS (12 Hours) : {{wikiRateLos?.opsDashboardDetail2?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES LOS (12 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_LOS_FROM_YIELDMAX', 12)">{{wikiRateLos?.opsDashboardDetail2?.rateSyncNumError}}</a> </p>
                    </div>
                    <div class="mt-4">
                      <p>SUCCESS SYNCED RATE LOS (24 Hours) : {{wikiRateLos?.opsDashboardDetail3?.rateSyncNumSuccess}} </p>
                      <p>ERROR   SYNCED RATES LOS (24 Hours) : <a href="javascript:void(0);" (click)="onWikiErrorClick('ERROR', 'SYNC_RATE_LOS_FROM_YIELDMAX', 24)">{{wikiRateLos?.opsDashboardDetail3?.rateSyncNumError}}</a> </p>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="mt-4 ml-2">
                      <p>SYNCED RATES Min Time in Sec (4 Hours) : {{wikiRates?.opsDashboardDetail1?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATES Avg Time in Sec (4 Hours) : {{wikiRates?.opsDashboardDetail1?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATES Max Time in Sec (4 Hours) : {{wikiRates?.opsDashboardDetail1?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                    <div class="mt-4 ml-2">
                      <p>SYNCED RATES Min Time in Sec (12 Hours) : {{wikiRates?.opsDashboardDetail2?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATES Avg Time in Sec (12 Hours) : {{wikiRates?.opsDashboardDetail2?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATES Max Time in Sec (12 Hours) : {{wikiRates?.opsDashboardDetail2?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                    <div class="mt-4 ml-2">
                      <p>SYNCED RATES Min Time in Sec (24 Hours) : {{wikiRates?.opsDashboardDetail3?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATES Avg Time in Sec (24 Hours) : {{wikiRates?.opsDashboardDetail3?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATES Max Time in Sec (24 Hours) : {{wikiRates?.opsDashboardDetail3?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="mt-4">
                      <p>SYNCED RATE LOS Min Time in Sec (4 Hours) : {{wikiRateLos?.opsDashboardDetail1?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATE LOS Avg Time in Sec (4 Hours) : {{wikiRateLos?.opsDashboardDetail1?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATE LOS Max Time in Sec (4 Hours) : {{wikiRateLos?.opsDashboardDetail1?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                    <div class="mt-4">
                      <p>SYNCED RATE LOS Min Time in Sec (12 Hours) : {{wikiRateLos?.opsDashboardDetail2?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATE LOS Avg Time in Sec (12 Hours) : {{wikiRateLos?.opsDashboardDetail2?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATE LOS Max Time in Sec (12 Hours) : {{wikiRateLos?.opsDashboardDetail2?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                    <div class="mt-4">
                      <p>SYNCED RATE LOS Min Time in Sec (24 Hours) : {{wikiRateLos?.opsDashboardDetail3?.rateSyncProcTime?.minProcTime}} </p>
                      <p>SYNCED RATE LOS Avg Time in Sec (24 Hours) : {{wikiRateLos?.opsDashboardDetail3?.rateSyncProcTime?.avgProcTime}} </p>
                      <p>SYNCED RATE LOS Max Time in Sec (24 Hours) : {{wikiRateLos?.opsDashboardDetail3?.rateSyncProcTime?.maxProcTime}} </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
                <p-table #pt [value]="opsDashboardDetails" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="opsDashboardId" selectionMode="single"
                  [loading]="formLoading" [paginator]="showPagination" [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
                  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
                  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
                  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

                  <ng-template pTemplate="header">
                    <tr>
                      @for (col of columns; track col) {
                        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                          {{col.header}}
                          <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                      }
                      <th [ngStyle]="{'width': 'auto'}"></th>
                    </tr>
                    @if (showFilter) {
                      <tr>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'opsDashboardId', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrUnit', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyName', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'numBedrooms', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'numBathrooms', 'in')"></th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                      </tr>
                    }
                  </ng-template>
                  <ng-template pTemplate="body" let-opsDashboard>
                    <tr [pSelectableRow]="opsDashboard">
                      <td>{{opsDashboard.opsDashboardId}} </td>
                      <td>{{opsDashboard.title}}</td>
                      <td>{{opsDashboard.resultLabel}}</td>
                      <td>{{opsDashboard.resultData}}</td>
                      <td>{{opsDashboard.asOfDate}}</td>
                      <td [ngStyle]="opsDashboard.status == 'SUCCESS' ? {'background-color':'lightgreen'} : opsDashboard.status == 'ERROR' ? {'background-color':'red'} : opsDashboard.status == 'WARN' ? {'background-color':'yellow'} : {'background-color': 'lightblue'}" >
                      {{opsDashboard.status}}</td>
                      <td>{{opsDashboard.referenceId}}</td>
                      <td>{{opsDashboard.description}}</td>
                      <td>{{opsDashboard.createDate}}</td>
                    </tr>
                  </ng-template>
                </p-table>

                <p-dialog
                  header="Dashboard Details"
                  [modal]="true"
                  [(visible)]="showMessageInfoDialog"
                  [style]="{ width: '100rem', height:'100rem' }"
                  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
                  [maximizable]="true">
                  <p-table
                    [value]="logmanAPIList"
                    styleClass="p-datatable-gridlines"
                    [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Severity</th>
                        <th>Reference</th>
                        <th>Message</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-logmanAPI>
                      <tr>
                        <td>{{ logmanAPI.severity }}</td>
                        <td>{{ logmanAPI.referenceId }}</td>
                        <td>{{ logmanAPI.message }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-dialog>
              <!--</ng-template>-->
            </p-tabPanel>
            <!-- <p-tabPanel header="Reservation" (click)="onTabChange(1)" id="1">
            <div class="container-fluid" *ngIf="activeTabIndex === 1">
              <p-toast [style]="{marginTop: '80px'}"></p-toast>
              <div class="progress-spinner" *ngIf="formLoading">
                <app-spinner [formLoading]="formLoading"></app-spinner>
              </div>

              <h2>Reservations</h2>

              <app-reservation-report></app-reservation-report>
            </div>

          </p-tabPanel> -->
        </p-tabView>
      </div>
